// @ts-nocheck
import { Envs, Utils } from '../../common';
import { React, ReactDOM, Styled, StyledF } from '../../common/3rd';
import { ButtonType, StyledProps } from '../../types';
import Styles, { Phone, StyledComponents } from '../../styles';

const Wrapper = Styled.div.attrs({
	'data-widget': 'alert-wrapper'
})`
	position: relative;
	display: ${(props: { shown?: boolean }) => (props.shown ? 'block' : 'none')};
	${(props: any) => {
		if (!props.hint) {
			return '';
		}

		return `
			div[data-widget=alert-box] {
				top: 100vh;
				transition: top 400ms ease-in-out;
				color: ${props.theme.ALERT_HINT_COLOR || props.theme.STANDARD_FONT_COLOR};
			}
			div[data-widget=alert-body] {
				border-radius: ${props.theme.ALERT_HINT_BORDER_RADIUS || props.theme.STANDARD_ALERT_HINT_BORDER_RADIUS};
				background-color: ${props.theme.ALERT_HINT_BACKGROUND_COLOR || props.theme.STANDARD_ALERT_HINT_BACKGROUND_COLOR};
				> i[data-widget=alert-icon] {
					color: ${props.theme.ALERT_HINT_ICON_COLOR};
				}
			}
			div[data-widget=alert-msg-block] {
				min-height: auto;
				span:first-child {
					min-height: auto;
				}
			}
			div[data-widget=alert-msg-line] {
				word-break: keep-all;
			}
			${props.hintIn
				? `
				div[data-widget=alert-box] {
					top: 60vh;
				}
			`
				: ''
			}
			${props.hintOut
				? `
				div[data-widget=alert-box] {
					top: -10vh;
					color: ${props.theme.ALERT_HINT_COLOR || props.theme.STANDARD_FONT_COLOR};
				}
			`
				: ''
			}
		`;
	}}

	${(props: any) => {
		if (!props.fadeAway) {
			return '';
		}

		return `
			div[data-widget=alert-box] {
				color: ${props.theme.ALERT_FADEAWAY_COLOR || props.theme.STANDARD_FONT_COLOR};
			}
			div[data-widget=alert-body] {
				border-radius: ${props.theme.ALERT_FADEAWAY_BORDER_RADIUS || props.theme.STANDARD_ALERT_FADEAWAY_BORDER_RADIUS};
				background-color: ${props.theme.ALERT_FADEAWAY_BACKGROUND_COLOR || props.theme.STANDARD_ALERT_FADEAWAY_BACKGROUND_COLOR};
				> i[data-widget=alert-icon] {
					color: ${props.theme.ALERT_HINT_ICON_COLOR};
				}
			}
			div[data-widget=alert-msg-block] {
				min-height: auto;
				span:first-child {
					min-height: auto;
				}
			}
			div[data-widget=alert-msg-line] {
				word-break: keep-all;
			}

			${props.hintOut
				? `
				div[data-widget=alert-box] {
					// animation-name: fadeOut; /*动画名称*/
					// // animation-duration: 2s; /*动画持续时间*/
					// animation-iteration-count: 1; /*动画次数*/
					// animation-delay: 0s; /*延迟时间*/
					// -webkit-animation-name: fadeOut; /*动画名称*/
					// // -webkit-animation-duration: 2s; /*动画持续时间*/
					// -webkit-animation-iteration-count: 1; /*动画次数*/
					// -webkit-animation-delay: 0s; /*延迟时间*/

					@keyframes fadeOut {
						0% {
							opacity: 1; /*初始状态 透明度为0*/
						}
						10% {
							opacity: 0.9; /*中间状态 透明度为0*/
						}
						20% {
							opacity: 0.8; /*中间状态 透明度为0*/
						}
						30% {
							opacity: 0.7; /*中间状态 透明度为0*/
						}
						40% {
							opacity: 0.6; /*中间状态 透明度为0*/
						}
						50% {
							opacity: 0.5; /*中间状态 透明度为0*/
						}
						60% {
							opacity: 0.4; /*中间状态 透明度为0*/
						}
						70% {
							opacity: 0.3; /*中间状态 透明度为0*/
						}
						80% {
							opacity: 0.2; /*中间状态 透明度为0*/
						}
						90% {
							opacity: 0.1; /*中间状态 透明度为0*/
						}
						100% {
							opacity: 0; /*结尾状态 透明度为1*/
						}
					}
				}
			`
				: ''
			}
		`;
	}}

` as any;

const Backdrop = Styled.div.attrs({
	'data-widget': 'alert-backdrop'
})`
	display: block;
	position: fixed;
	width: 100vw;
	height: 100vh;
	top: 0;
	// background-color: ${props => props.theme.BACKDROP_COLOR};
	z-index: ${props => props.theme.ALERT_Z_INDEX};

	${(props: any) => {
		if (![Alert.HINT, Alert.FADE_AWAY,  Alert.TIMING].includes(props['data-type'])) {
			return `
				opacity: 0.31;
				background-color: #000000;
			`;
		}
	}}
`;

const Box = Styled.div.attrs({
	'data-widget': 'alert-box'
})`
	display: block;
	position: fixed;
	top: ${props => props.theme.ALERT_BOX_TOP || props.theme.STANDARD_ALERT_BOX_TOP};
	left: 35vw;
	max-height: 50vh;
	width: 30vw;
	border-radius: ${props => props.theme.ALERT_BORDER_RADIUS || props.theme.STANDARD_ALERT_BORDER_RADIUS};
	padding: ${props => props.theme.PANEL_PADDING}px;
	// background: ${props => props.theme.PANEL_BACKGROUND_COLOR};
	z-index: ${props => props.theme.ALERT_Z_INDEX + 1};
	
	${(props: any) => {
		if (props['data-type'] === Alert.INFO
			|| props['data-type'] === Alert.ASK
			|| props['data-type'] === Alert.SUCCESS
			|| props['data-type'] === Alert.WARN
			|| props['data-type'] === Alert.LOADING
			|| props['data-type'] === Alert.ERROR
			|| props['data-type'] === Alert.ASK_REVERSED) {
			return `box-shadow: ${props.theme.ALERT_SHADOW};
				background: ${props.theme.PANEL_BACKGROUND_COLOR};
			`
		}
		return ``;
	}}

	${Phone.only`
		padding: 0;
		width: 80vw;
		left: 10vw;
	`}
`;

const Body = Styled.div.attrs({
	'data-widget': 'alert-body'
})`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	overflow: hidden;
	margin-bottom: ${props => props.theme.MARGIN}px;
	background:#fff;
	
	border-top-left-radius:${props => props.theme.ALERT_BORDER_RADIUS || props.theme.STANDARD_ALERT_BORDER_RADIUS};
	border-top-right-radius: ${props => props.theme.ALERT_BORDER_RADIUS || props.theme.STANDARD_ALERT_BORDER_RADIUS};
	${(props: any) => {
		if (props['data-type'] === Alert.LOADING
			|| props['data-type'] === Alert.HINT
			|| props['data-type'] === Alert.FADE_AWAY
		) {
			return `
				border-bottom-left-radius: ${props.theme.ALERT_BORDER_RADIUS || props.theme.STANDARD_ALERT_BORDER_RADIUS};
				border-bottom-right-radius: ${props.theme.ALERT_BORDER_RADIUS || props.theme.STANDARD_ALERT_BORDER_RADIUS};
			`
		}
		return ``;
	}}
	${Phone.only`
		padding: ${(props: StyledProps) => props.theme.PANEL_PADDING}px;
		margin-bottom: 0;
	`}
`;

const Rotate = StyledF.keyframes`
	from {transform: rotate(0deg);}
	to {transform: rotate(360deg);}
`;

const Spinner = Styled.div.attrs({
	'data-widget': 'alert-spinner'
})`
	width: 3px; 
	height: 3px;
	margin: 16px 20px;
	border-radius: 100%;                      /* 圆角 */
	box-shadow: 0 -10px 0 1px grey,           /* 上, 1px 扩展 */
				10px 0px grey,                /* 右 */    
				0 10px grey,                  /* 下 */
				-10px 0 grey,                 /* 左 */
							
				-7px -7px 0 .5px grey,        /* 左上, 0.5px扩展 */
				7px -7px 0 1.5px grey,        /* 右上, 1.5px扩展 */                    
				7px 7px grey,                 /* 右下 */
				-7px 7px grey;                /* 左下 */
	animation: 2s linear infinite;
	animation-name: ${Rotate};
`;

const Icon = (props: any) => (
	<StyledComponents.FAS
		data-widget="alert-icon"
		{...props}
		css={props => {
			return `
				height: ${props.theme.MIDDLE_HEIGHT}px;
				line-height: ${props.theme.MIDDLE_HEIGHT}px;
				width: ${props.theme.ICON_WIDTH}px;
				min-width: ${props.theme.ICON_WIDTH}px;
				font-size: 24px;
				display: ${props.theme.ALERT_MSG_ICON_DISPLAY};
			`;
		}}
	/>
);

const MsgHeader = Styled.div.attrs({
	'data-widget': 'alert-msg-header'
})`
	display:none;
	text-align: center;
	padding-top:15px;
	padding-bottom:16px;
	font-weight: 400;
	font-size: 16px;
	line-height: 16px;
	font-style: normal;
	text-decoration: none;	

	${(props: any) => {
		if (props['data-type'] === Alert.INFO
			|| props['data-type'] === Alert.WARN
			|| props['data-type'] === Alert.ERROR
			|| props['data-type'] === Alert.ASK
			|| props['data-type'] === Alert.ASK_APPLY
			|| props['data-type'] === Alert.ASK_REVERSED
			|| props['data-type'] === Alert.SUCCESS) {
			return `display: ${props.theme.ALERT_MSG_HEADER_DISPLAY};`
		}
		return ``;
	}}
`;

const MsgBlock = Styled.div.attrs({
	'data-widget': 'alert-msg-block'
})`
	flex-grow: 1;
	min-height: ${props => props.theme.ALERT_MSG_BLOCK_MIN_HEIGHT};
	max-height: calc(50vh - ${props => props.theme.PANEL_PADDING * 2 + props.theme.MARGIN + props.theme.BTN_HEIGHT}px);
	overflow-y: auto;
	overflow-x: hidden;
    // color:#fff;
	display:flex;
	flex-direction: row;
	padding:0 12px;

	span:first-child {
		margin-top: ${props => (props.theme.MIDDLE_HEIGHT - props.theme.SHORT_HEIGHT) / 2}px;
	}
`;

const MsgLine = Styled.span.attrs({
	'data-widget': 'alert-msg-line'
})`
	display: block;
	position: relative;
	word-break: break-word;
	font-weight: 300;
	min-height: ${props => props.theme.SHORT_HEIGHT}px;
	line-height: 20px;
	${(props: any) => {
		if (props['data-type'] === Alert.LOADING) {
			return `text-align:left;`
		}
		if (props['data-type'] === Alert.FADE_AWAY
			|| props['data-type'] === Alert.HINT) {
			return `text-align:${props.theme.ALERT_MSG_LINE_TEXT_ALIGN};`
		}
		//@ts-ignore
		if (props['data-rows'] == '1') {
			return `text-align:${props.theme.ALERT_MSG_LINE_TEXT_ALIGN};`
		}
		return `text-align:left`;
	}}
`;

const MsgBody = Styled.div.attrs({
	'data-widget': 'alert-msg-body'
})`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

const ButtonBar = Styled.div.attrs({
	'data-widget': 'alert-btn-bar'
})`
	display: flex;
	justify-content: flex-end;
	border-bottom-left-radius: ${props => props.theme.ALERT_BORDER_RADIUS || props.theme.STANDARD_ALERT_BORDER_RADIUS};
	border-bottom-right-radius: ${props => props.theme.ALERT_BORDER_RADIUS || props.theme.STANDARD_ALERT_BORDER_RADIUS};
	${(props: any) => {
		if (props['data-type'] === Alert.LOADING
			|| props['data-type'] === Alert.HINT
			|| props['data-type'] === Alert.FADE_AWAY
		) {
			return `
				border-top-left-radius:${props.theme.ALERT_BORDER_RADIUS || props.theme.STANDARD_ALERT_BORDER_RADIUS};
				border-top-right-radius: ${props.theme.ALERT_BORDER_RADIUS || props.theme.STANDARD_ALERT_BORDER_RADIUS};
			`
		}
		return ``;
	}}
	background: ${props => props.theme.PANEL_BACKGROUND_COLOR};
	padding-top:${props => props.theme.ALERT_BUTTON_BAR_PADDING_TOP};
	padding-bottom:${props => props.theme.ALERT_BUTTON_BAR_PADDING_BOTTOM};
	
	a {
		margin: 0 auto;
		flex-grow:${props => props.theme.ALERT_BUTTON_BAR_A_FLEX_GROW};
		max-width:${props => props.theme.ALERT_BUTTON_BAR_A_MAX_WIDTH};
		width:${props => props.theme.ALERT_BUTTON_BAR_A_WIDTH};
		border-top-left-radius: ${props => props.theme.ALERT_BUTTON_BAR_A_BORDER_TOP_LEFT_RADIUS};
		border-top-right-radius: ${props => props.theme.ALERT_BUTTON_BAR_A_BORDER_TOP_RIGHT_RADIUS};
		border-bottom-left-radius: ${props => props.theme.ALERT_BUTTON_BAR_A_BORDER_BOTTOM_LEFT_RADIUS};
		border-bottom-right-radius: ${props => props.theme.ALERT_BUTTON_BAR_A_BORDER_BOTTOM_RIGHT_RADIUS};

		&[type=waive]{
			background-color: ${props => props.theme.ALERT_WAIVE_BTN_BACKGROUND_COLOR};
			color: ${props => props.theme.ALERT_WAIVE_BTN_COLOR};
			border:${props => props.theme.ALERT_WAIVE_BTN_BORDER};
		}
	}
	
`;

const Button = Styled(StyledComponents.BUTTON).attrs({
	'data-widget': 'alert-btn'
})`
	height: ${props => props.theme.ALERT_BUTTON_HEIGHT || props.theme.ROW_HEIGHT}px;
	line-height: ${props => props.theme.ALERT_BUTTON_HEIGHT || props.theme.ROW_HEIGHT - props.theme.ALERT_BTN_VERTICAL_PADDING || props.theme.BTN_VERTICAL_PADDING * 2}px;
	padding: 0;

`;

/**
 * 警告对话框, 包括WARN, INFO, SUCCESS, ASK, ASK-REVERSE, LOADING
 */
class Alert extends React.Component {
	static WARN = 'w';
	static SUCCESS = 's';
	static INFO = 'i';
	static ERROR = 'e';
	static ASK = 'q';
	static LOADING = 'l';
	static ASK_REVERSED = 'qr';
	static HINT = 'h';
	static FADE_AWAY = 'fa';//渐渐消息
	static ASK_APPLY = 'qa';//
	state: {
		reverseColors?: string | null;
		type?: string | null;
		messages?: string | string[] | null;
		active?: HTMLElement | null;
		resolve?: (arg?: any) => void | null;
		reject?: (arg?: any) => void | null;
		hintIn?: true;
		hintOut?: true;
		confirmLabel?: string;
		cancelLabel?: string;
	} = {};
	private renderButtons(): JSX.Element | null {
		if (this.state.type === Alert.HINT) {
			return null;
		}
		if (this.state.type === Alert.FADE_AWAY) {
			return null;
		}

		const waive = this.state.reverseColors ? ButtonType.PRIMARY : ButtonType.WAIVE;
		const primary = this.state.reverseColors ? ButtonType.WAIVE : ButtonType.PRIMARY;
		if (this.state.type === Alert.ASK) {
			return (
				<ButtonBar data-type={this.state.type}>
					<Button onClick={this.onCancelClicked} type={waive}>
						{this.state.cancelLabel || '取消'}
					</Button>
					<Button onClick={this.onConfirmClicked} type={primary}>
						{this.state.confirmLabel || '确认'}
					</Button>
				</ButtonBar>
			);
		} else if (this.state.type === Alert.ASK_REVERSED) {
			return (
				<ButtonBar data-type={this.state.type}>
					<Button onClick={this.onConfirmClicked} type={primary}>
						{this.state.confirmLabel || '确认'}
					</Button>
					<Button onClick={this.onCancelClicked} type={waive}>
						{this.state.cancelLabel || '取消'}
					</Button>
				</ButtonBar>
			);
		} else if (this.state.type === Alert.ASK_APPLY) {
			return (
				<ButtonBar data-type={this.state.type}>
					<Button onClick={this.onCancelClicked} type={waive}>
						{this.state.cancelLabel || '取消投保'}
					</Button>
					<Button onClick={this.onConfirmClicked} type={primary}>
						{this.state.confirmLabel || '继续投保'}
					</Button>
				</ButtonBar>
			);
		} else if (this.state.type === Alert.LOADING) {
			return null;
		} else {
			return (
				<ButtonBar data-type={this.state.type}>
					<Button onClick={this.onConfirmClicked} type={ButtonType.PRIMARY}>
						{this.state.confirmLabel || '确认'}
					</Button>
				</ButtonBar>
			);
		}
	}

	private renderMessages(): JSX.Element {
		let messages = Utils.toArray(this.state.messages);
		return (<React.Fragment>
			{this.renderIcon()}
			<MsgBody>
				{(messages || []).map((msg, index) => {
					return (
						<MsgLine data-type={this.state.type} data-rows={messages.length} key={index} data-widget="alert-msg-line">
							{msg}
						</MsgLine>
					);
				})}
			</MsgBody>
		</React.Fragment>);
	}
	private renderIcon(): JSX.Element {
		const props: {
			icon?: string;
			color?: string;
			spin?: boolean;
			className?: string;
		} = {};
		switch (this.state.type) {
			case Alert.WARN:
				props.icon = 'exclamation-circle';
				props.color = 'warn';
				break;
			case Alert.SUCCESS:
				props.icon = 'check-circle';
				props.color = 'success';
				break;
			case Alert.INFO:
			case Alert.HINT:
			case Alert.FADE_AWAY:
				props.icon = 'info-circle';
				props.color = 'info';
				break;
			case Alert.ERROR:
				props.icon = 'times-circle';
				props.color = 'error';
				break;
			case Alert.ASK:
			case Alert.ASK_REVERSED:
			case Alert.ASK_APPLY:
				props.icon = 'question-circle';
				props.color = 'question';
				break;
			case Alert.LOADING:
				props.icon = 'spinner';
				props.color = 'info';
				props.spin = true;
				break;
			default:
				props.icon = 'info-circle';
				props.color = 'info';
				props.className = 'fa-spin';
				break;
		}
		if (props.spin) {
			return <Spinner />;
		} else {
			return <Icon {...props} data-widget="alert-icon" />;
		}
	}
	render(): JSX.Element {
		if (this.state.type) {
			return (
				<StyledF.ThemeProvider theme={Styles.getTheme(Envs.getCurrentTheme())}>
					<Wrapper
						shown={this.isShown()}
						fadeAway={this.state.type === Alert.FADE_AWAY}
						hint={this.state.type === Alert.HINT}
						hintIn={this.state.hintIn}
						hintOut={this.state.hintOut}
					>
						<Backdrop data-type={this.state.type} />
						<Box data-type={this.state.type}>
							<Body data-type={this.state.type}>
								<MsgHeader data-type={this.state.type}>提示</MsgHeader>
								<MsgBlock>
									{this.renderMessages()}
								</MsgBlock>
							</Body>
							{this.renderButtons()}
						</Box>
					</Wrapper>
				</StyledF.ThemeProvider>
			);
		} else {
			return <div />;
		}
	}
	warn(messages: string | string[]): Promise<void> {
		return this.show(messages, Alert.WARN);
	}
	error(messages: string | string[]): Promise<void> {
		return this.show(messages, Alert.ERROR);
	}
	info(messages: string | string[]): Promise<void> {
		return this.show(messages, Alert.INFO);
	}
	success(messages: string | string[]): Promise<void> {
		return this.show(messages, Alert.SUCCESS);
	}
	ask(messages: string | string[],
		options?: {
			reverseButtons?: boolean;
			reverseButtonColors?: boolean;
			apply?: boolean;
			confirmLabel?: string;
			cancelLabel?: string;
		}): Promise<void> {
		const { reverseButtons = false, reverseButtonColors = false, apply = false } = options || {};
		return this.show(messages, apply ? Alert.ASK_APPLY : reverseButtons ? Alert.ASK_REVERSED : Alert.ASK, options);
	}
	loading(): Promise<void> {
		return this.show('努力加载中...', Alert.LOADING);
	}
	posting(): Promise<void> {
		return this.show('提交数据中...', Alert.LOADING);
	}
	ing(message: string): Promise<void> {
		return this.show(message, Alert.LOADING);
	}
	hint(message: string | string[]): Promise<void> {
		return this.show(message, Alert.HINT);
	}
	fadeAway(message: string | string[]): Promise<void> {
		return this.show(message, Alert.FADE_AWAY);
	}
	show(messages: string | string[], type: string, options?: {
		reverseButtonColors?: boolean;
		confirmLabel?: string;
		cancelLabel?: string;
		time?: number; //时间，秒
	}): Promise<void> {
		const { cancelLabel, confirmLabel, reverseButtonColors = false, time = 0 } = options || {};
		if (this.isShown()) {
			// 已经在显示状态
			this.hide();
		}

		return new Promise((resolve, reject) => {
			// 弹框, 记录活动的元素
			// 去掉焦点, 实际上是为了在移动设备上去掉软键盘
			const active = document.activeElement as HTMLElement;
			active && active.blur();

			this.setState(
				{
					messages: messages,
					type: type,
					reverseColors: reverseButtonColors,
					resolve: resolve,
					reject: reject,
					confirmLabel,
					cancelLabel,
					time,
					active: active
				},
				() => {
					Envs.application()!.setScrollDisabled(true);
					if (type === Alert.HINT) {
						// 30毫秒后进入屏幕
						setTimeout(() => {
							this.setState(
								{
									hintIn: true
								},
								() => { // NOSONAR
									// 位置停稳后, 再过3秒钟后移出屏幕
									setTimeout(() => {
										this.setState(
											{
												hintOut: true
											},
											() => {
												// 移出屏幕后关闭
												setTimeout(() => {
													this.hide();
												}, 400);
											}
										);
									}, 2400);
								}
							);
						}, 30);
					}

					if (type === Alert.FADE_AWAY) {
						this.setState(
							{
								hintIn: true
							},
							() => {
								// 位置停稳后, 再过3秒钟后移出屏幕
								setTimeout(() => { // NOSONAR
									this.setState(
										{
											hintOut: true
										},
										() => {
											// 移出屏幕后关闭
											setTimeout(() => {
												this.hide();
											}, 900);
										}
									);
								}, 1000);
							}
						);
					}
				}
			);
		});
	}
	progress(messages: string | string[]): void {
		this.setState({
			messages: messages
		});
	}
	/**
	 * 隐藏警告对话框, 默认resolve promise
	 */
	hide(resolved = true): void {
		const handlePromise: any = resolved ? this.state.resolve : this.state.reject;
		const active = this.state.active;
		// remove all states
		this.setState(
			{
				messages: undefined,
				type: undefined,
				reverseColors: undefined,
				resolve: undefined,
				reject: undefined,
				active: undefined,
				hintIn: undefined,
				hintOut: undefined
			},
			() => {
				Envs.application()!.setScrollDisabled(false);
				// 恢复焦点
				active && active.focus();
				handlePromise && handlePromise();
			}
		);
	}
	isShown(): boolean {
		return this.state.messages != null;
	}
	private onConfirmClicked = (): void => {
		this.hide(true);
	};
	private onCancelClicked = (): void => {
		this.hide(false);
	};
	// redressPosition() {
	// 	setTimeout(() => {
	// 		const scrollTop = document.body.scrollTop;
	// 		if (Envs.iphone && Envs.wechat && scrollTop !== 0) {
	// 			const focus = document.activeElement;
	// 			if (focus != null && focus.tagName !== 'BODY') {
	// 				const tagName = focus.tagName.toUpperCase();
	// 				const shouldAdjust = (() => {
	// 					if (tagName === 'SELECT' || tagName === 'TEXTAREA') {
	// 						// keyboard is shown
	// 						return true;
	// 					} else if (tagName === 'INPUT') {
	// 						const type = (
	// 							focus.getAttribute('type') || ''
	// 						).toUpperCase();
	// 						if (
	// 							type === 'TEXT' ||
	// 							type === 'PASSWORD' ||
	// 							type === 'DATE'
	// 						) {
	// 							// keyboard is shown
	// 							return true;
	// 						}
	// 					}
	// 					return false;
	// 				})();
	// 				this.setState({
	// 					keyboard: shouldAdjust
	// 				});
	// 			}
	// 		}
	// 	}, 30);
	// }
}

let container = document.getElementById('new-alert-container');
if (container == null) {
	container = document.createElement('DIV');
	container.id = 'new-alert-container';
	document.body.appendChild(container);
}

const AlertRef = React.createRef() as React.RefObject<Alert>;
ReactDOM.render(<Alert ref={AlertRef} />, container);
export default AlertRef.current as AlertNew;
